import { AxiosError } from 'axios';
import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { spotlightKeys } from './spotlightKeys';

interface IGetSpotlightsLeftCount {
  enabled: boolean;
  max: number;
  used: number;
  left: number;
}

const getSpotlightsLeftCount = async (): Promise<IGetSpotlightsLeftCount> => {
  return (await EXPRESS_API.get(`/quick-videos/spotlight/count`))
    .data as IGetSpotlightsLeftCount;
};

export const useGetSpotlightsLeftCount = () => {
  return useQuery(spotlightKeys.count(), () => getSpotlightsLeftCount(), {
    onError: (err: AxiosError) => console.log(err),
    refetchOnMount: true,
  });
};
